// export const BASEURL = `https://starcinemas-api.brij.tech/`;

export const BASEURL = `https://mifcentral-api.brij.tech`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://mifcentral-api.brij.tech`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const Mifcentral = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImQ3YTAzYTY5LTMwMGUtNGM0ZS1hNTM4LTQyZjU0N2I4Y2ExYyIsImlhdCI6MTc1OTk4OTAxNH0.rpygvuJK8zKZw1QCYMIR6_g8CmOIkv9BDVxwOGtBHy0`
export const TOKEN = Mifcentral



// WEBPACK FOOTER //
// ./src/config/index.js